export const BundleEndpoints = {
  bundles: (slug: string) => `/rest/public/v1/bundles/${slug}/sale`,
  products: (bundleId: number, slug: string) =>
    `/rest/public/v1/bundles/${slug}/${bundleId}/products`
}
